import { connect } from 'react-redux';
import {
  compose,
  setDisplayName,
  lifecycle,
  mapProps,
  renameProp,
  withStateHandlers,
  pure
} from 'recompose';
import { createSelector } from 'reselect';
import { withErrors, withForm } from 'recompose-extends';

import NewsComments from '../../views/News/NewsComments';
import {
  loadComments,
  loadMoreComments,
  newComment,
  replyComment,
  loadAllReplies,
  removeComment
} from '../../../actions';
import { selectComments } from '../../../selectors';
import { A3MIL_USER_ID } from '../../../constants/content';

export default compose(
  setDisplayName('NewsCommentsContainer'),
  withErrors(),
  connect(
    createSelector(selectComments(), comments => ({
      comments
    })),
    {
      loadComments,
      loadMoreComments,
      newComment,
      replyComment,
      removeComment,
      loadAllReplies
    }
  ),
  lifecycle({
    componentDidMount() {
      this.props.loadComments(this.props.id);
    }
  }),
  withStateHandlers(({ numComments }) => ({ numComments }), {
    addComment: ({ numComments }) => () => ({ numComments: numComments + 1 }),
    // Al borrar un comentario principal se restan tambien sus respuestas
    subtractComment: ({ numComments }) => (amount = 1) => ({
      numComments: Math.max(numComments - amount, 0)
    })
  }),
  withForm(
    { comment: { value: '', required: true } },
    ({ id, newComment, resetForm, addComment }) => form => {
      newComment({ contentId: id, text: form.comment });
      resetForm();
      addComment();
    }
  ),
  mapProps(({ comments, ...rest }) => ({
    ...comments,
    ...rest
  })),
  renameProp('content', 'comments'),
  withStateHandlers(
    { answerId: null, answer: '' },
    {
      toggleAnswer: () => value => ({ answerId: value, answer: '' }),
      updateAnswer: () => event => ({ answer: event.target.value }),
      // sendAnswer() responde como el usuario conectado;
      // sendAnswer({ generic: true }) responde como A3Mil
      sendAnswer: ({ answer, answerId }, { id, replyComment, addComment }) => ({
        generic = false
      } = {}) => {
        replyComment({
          contentId: id,
          parentId: answerId,
          text: answer,
          ...(generic && { userId: A3MIL_USER_ID })
        });

        addComment();

        return {
          answer: '',
          answerId: null
        };
      }
    }
  ),
  withStateHandlers(
    {},
    {
      submitFormGenericComment: (state, props) => () => {
        props.newComment({
          contentId: props.id,
          text: props.form.comment,
          userId: A3MIL_USER_ID
        });
        props.resetForm();
        props.addComment();
      }
    }
  ),
  mapProps(({ submitFormGenericComment, ...rest }) => ({
    submitFormGenericComment,
    ...rest
  })),
  pure
)(NewsComments);
